import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api.js";

// Centralisation des routes API
const API_ROUTES = {
    GET_SELLER_DASHBOARD_INDEX_DATA: `/api/seller/get_seller_dashboard_index_data`,
    GET_ADMIN_DASHBOARD_INDEX_DATA: `/api/admin/get_admin_dashboard_index_data`,
    GET_ADMIN_DASHBOARD_STATS_DATA: `/api/admin/stats/get_admin_dashboard_stats_data`,
};

// Fonction utilitaire pour la gestion des messages d'erreur
const getErrorMessage = (error) => error.response?.data.message || error.message;

export const get_seller_dashboard_index_data = createAsyncThunk(
    "dashboardIndex/get_seller_dashboard_index_data",
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(
                API_ROUTES.GET_SELLER_DASHBOARD_INDEX_DATA,
                { withCredentials: true }
            );
         // console.log("Réponse de l'API get_seller_dashboard_index_data :", data);
          return fulfillWithValue(data);
        } catch (error) {
            //return rejectWithValue(error.response?.data?.message || "Une erreur inattendue est survenue");
            return rejectWithValue(getErrorMessage(error));
        }
    }
);

export const get_admin_dashboard_index_data = createAsyncThunk(
    "dashboardIndex/get_admin_dashboard_index_data",
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(
                API_ROUTES.GET_ADMIN_DASHBOARD_INDEX_DATA,
                { withCredentials: true }
            );
            //console.log("Réponse de l'API get_admin_dashboard_index_data :", data);
          return fulfillWithValue(data);
        } catch (error) {
            //return rejectWithValue(error.response?.data?.message || "Une erreur inattendue est survenue");
            return rejectWithValue(getErrorMessage(error));
        }
    }
);

// 🔹 Thunk : récupérer les stats avec filtres
export const get_admin_dashboard_stats_data = createAsyncThunk(
  "dashboard/get_admin_dashboard_index_data",
  async ({ from, to, sellerId }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`${API_ROUTES.GET_ADMIN_DASHBOARD_STATS_DATA}?from=${from}&to=${to}&sellerId=${sellerId}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Erreur serveur");
    }
  }
);



export const dashboardIndexReducer = createSlice({
    name: "dashboardIndex",
    initialState: {
        totalSales : 0,
        totalOrders : 0,
        totalProducts :0,
        totalPendingOrders :0,
        totalSellers : 0,
        recentOrders : [],
        recentMessages : [],
        errorMessage : '',
        successMessage : '',
        loading : false,
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = "";
            state.successMessage = "";
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(get_seller_dashboard_index_data.pending, (state) => {
                state.loading  = true;
                state.errorMessage = "";
            })
            .addCase(get_seller_dashboard_index_data.fulfilled, (state, action) => {
                state.loading  = false;
                state.totalSellers = action.payload?.totalSellers || 0;
                state.totalSales = action.payload?.totalSales || 0;
                state.totalOrders = action.payload?.totalOrders || 0;
                state.totalProducts = action.payload?.totalProducts || 0;
                state.totalPendingOrders = action.payload?.totalPendingOrders || 0;
                state.recentOrders = action.payload?.recentOrders || [];
                state.recentMessages = action.payload?.recentMessages || [];
            })
            .addCase(get_seller_dashboard_index_data.rejected, (state, action) => {
                state.loading  = false;
                state.errorMessage = action.payload;
            })

            .addCase(get_admin_dashboard_index_data.pending, (state) => {
                state.loading  = true;
                state.errorMessage = "";
            })
            .addCase(get_admin_dashboard_index_data.fulfilled, (state, action) => {
                state.loading  = false;
                state.totalSellers = action.payload?.totalSellers || 0;
                state.totalSales = action.payload?.totalSales || 0;
                state.totalOrders = action.payload?.totalOrders || 0;
                state.totalProducts = action.payload?.totalProducts || 0;
                
                state.recentOrders = action.payload?.recentOrders || [];
                state.recentMessages = action.payload?.recentMessages || [];
            })
            .addCase(get_admin_dashboard_index_data.rejected, (state, action) => {
                state.loading  = false;
                state.errorMessage = action.payload;
            })
            
            .addCase(get_admin_dashboard_stats_data.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(get_admin_dashboard_stats_data.fulfilled, (state, action) => {
                state.loading = false;
                state.dashboardStats = action.payload.data || [];
            })
            .addCase(get_admin_dashboard_stats_data.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { messageClear } = dashboardIndexReducer.actions;
export default dashboardIndexReducer.reducer;
